<template>
  <div v-if="!id||member.member_id">
    <div class="alert alert-info alert-dismissable" v-if="message">
      <p>{{message}}</p>
    </div>
    <div class="alert alert-danger alert-dismissable" v-if="Object.keys(errors).length">
      <template v-for="error in errors">
        <p v-for="v in error">{{v}}</p>
      </template>
    </div>
    <div class="row col-sm-12">
      <div class="pull-right" v-if="!member.deleted_at&&id">
        <button class="btn btn-danger" v-on:click="showDeleteModal">退会する</button>
      </div>
    </div>
    <text-group :label="'会員ID'" :val="member.member_id" :readonly="true" v-if="id"/>
    <text-group :label="'会員ID'" val="新規発番" :readonly="true" v-if="!id"/>


    <text-group :label="'入会ステータス'"
                v-if="id"
                :readonly="true"
                :val="member.membership_status">
    </text-group>

    <text-group :label="'閲覧期限'"
                v-if="id"
                v-model="member.review_expired_at"
                :val="member.review_expired_at">
    </text-group>

    <text-group :label="'お知らせメール設定'"
                :require="true">
      <template slot="text">
        <select v-model="member.is_notice" class="form-control">
          <option v-for="tag in this.$store.state.tags.is_notice" :value="tag.tag_value">
            {{tag.tag_name}}
          </option>
        </select>
      </template>
    </text-group>


    <text-group :label="'氏名'"
                :require="true"
                v-model="member.name"
                :val="member.name"></text-group>

    <text-group :label="'ふりがな'"
                :require="true"
                v-model="member.name_kana"
                :val="member.name_kana"></text-group>

    <text-group :label="'性別'"
                :require="true"
                v-if="this.$store.state.tags">
      <template slot="text">
        <select v-model="member.gender_id" class="form-control">
          <option value="0">性別を選択してください</option>
          <option v-for="tag_gender in this.$store.state.tags.gender_id" :value="tag_gender.tag_value">
            {{tag_gender.tag_name}}
          </option>
        </select>
      </template>
    </text-group>

    <text-group :label="'生年月日'"
                :require="true">
      <template slot="text">
        <Datepicker format="yyyy/MM/dd" language="ja" :value="member.birthday" v-model="member.birthday"></Datepicker>
      </template>
    </text-group>

    <text-group :label="'メールアドレス'"
                :require="true"
                v-model="member.mail"
                :val="member.mail"></text-group>


    <text-group :label="'パスワード'"
                :require="true"
                v-model="member.password"
                :val="member.password"></text-group>


    <text-group :label="'最寄駅'"
                :require="true"
                v-model="member.station"
                :val="member.station"></text-group>

    <text-group :label="'雇用形態'"
                :require="true"
                v-if="this.$store.state.tags">
      <template slot="text">
        <label v-for="tag_occupation_id in this.$store.state.tags.occupation_id">
          <input type="checkbox" v-model="member.occupation_id" :value="tag_occupation_id.tag_value">
          {{tag_occupation_id.tag_name}}　
        </label>
      </template>
    </text-group>

    <div class="form-group">
      <!--<div class="form-group" v-if="!member.deleted_at">-->
      <div class="col-sm-12">
        <button v-if="!id" class="btn btn-block btn-primary" v-on:click="showConfirm=true">会員登録</button>
        <button v-if="id" class="btn btn-block btn-primary" v-on:click="showConfirm=true">会員更新</button>
      </div>
    </div>
    <modal v-if="showConfirm" @close="showConfirm=false">
      <template v-if="id" slot="header">会員更新</template>
      <template v-if="!id" slot="header">会員登録</template>
      <template slot="body">
        <table class="table">
          <tbody>
          <table-row title="名前" :input="member.name"></table-row>
          <table-row title="ふりがな" :input="member.name_kana"></table-row>
          <table-row title="メールアドレス" :input="member.mail"></table-row>
          </tbody>
        </table>
      </template>
      <template slot="footer">
        <button class="btn " v-on:click="showConfirm=false">キャンセル</button>
        <button class="btn btn-primary" v-if="id" v-on:click="updateMember">上記の会員を更新</button>
        <button class="btn btn-primary" v-if="!id" v-on:click="createMember">上記の会員を登録</button>
      </template>
    </modal>
    <modal v-if="showDeleteModal" @close="showDeleteModal=false">
      <template v-if="id" slot="header">会員更新</template>
      <template slot="body">
        【{{member.name}}】様の退会処理をします。<br/>
        再入会する場合は、再度会員登録を行って頂く必要があります。
      </template>
      <template slot="footer">
        <button class="btn " v-on:click="showDeleteModal=false">キャンセル</button>
        <button class="btn btn-primary" v-if="id" v-on:click="quitMember">退会処理を実行</button>
      </template>
    </modal>
  </div>
</template>
<script>
  import Api from '../../service/Api.vue'
  import moment from 'moment'

  export default {
    props: [
      'id'
    ],
    data () {
      return {
        showConfirm: false,
        showDeleteModal: false,
        message: '',
        errors: [],
        tags: [],
        member: {
          is_notice: 0,
          member_id: '',
          gender_id: 0,
          name: '',
          mail: '',
          password: '',
          birthday: '',
          occupation_id: []

        }
      }
    },
    created: function () {
      if (this.id) {
        Api.member.get(this.id)
          .then(this.showSuccess)
          .catch(this.showTrashed)
      }
      this.tags = this.$store.state.tags
    },
    watch: {
      'this.$store.state.tags': function () {
        this.tags = this.$store.state.tags
      }
    },
    methods: {
      showSuccess: function (response) {
        this.member = response.data.member
      },
      showFailure: function (errors) {
        var data = errors.response.data
        this.errors = data.errors
      },
      // 会員登録
      createMember: function () {
        let member = this.member
        member.birthday = moment(this.member.birthday).format('YYYY/MM/DD')
        Api.member.post(member)
          .then(this.completeMember)
          .catch(this.completeMemberError)
      },
      // 会員更新
      updateMember: function () {
        let member = this.member
        member.birthday = moment(this.member.birthday).format('YYYY/MM/DD')
        Api.member.put(this.id, this.member)
          .then(this.completeMember)
          .catch(this.completeMemberError)
      },
      // 会員套路完了
      completeMember: function () {
        this.showConfirm = false
        this.errors = []
        if (this.id) {
          Api.member.get(this.id)
            .then(this.showSuccess)
            .catch(this.showTrashed)
          this.message = '会員を更新しました'
        } else {
          this.message = '会員を登録しました'
          var member = this.member
          Object.keys(member).forEach(function (key) {
            member[key] = ''
          })
          this.member = member
        }
      },
      completeMemberError: function (errors) {
        this.showConfirm = false
        var data = errors.response.data
        this.errors = data.errors
        this.message = ''
      }
      // quitMember: function () {
      //   Api.member.remove(this.member.member_id)
      //     .then(this.successQuit)
      //     .catch(this.failureQuit)
      // },
      // successQuit (response) {
      //   this.showDeleteModal = false
      //   this.errors = []
      //   if (this.id) {
      //     Api.member.get(this.id)
      //       .then(this.showSuccess)
      //       .catch(this.showTrashed)
      //   }
      //   this.message = '退会処理をしました'
      // },
      // showTrashed: function () {
      //   Api.member.getOnlyTrashed(this.id)
      //     .then(this.showSuccess)
      //     .catch(this.showFailure)
      // },
      // failureQuit (errors) {
      //   this.showDeleteModal = false
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?7347fddd